import * as React from 'react'
import PropTypes from 'prop-types'
import { graphql } from 'gatsby'

export const ParagraphSection = ({ section, className = 'my-6 leading-loose' }) => {
  const { heading, content, fields } = section
  let paragraphWithUpdatedImages 
  paragraphWithUpdatedImages = fields ? fields.contentImg : null
  const htmlToRender = paragraphWithUpdatedImages ? paragraphWithUpdatedImages : content
  const contentHtml = {
    __html:
      (heading ? `<h2 class="underline-title my-5">${heading}</h2>` : '') +
      htmlToRender
  }
  return (
    <section className={className || 'my-6 leading-loose cms'} dangerouslySetInnerHTML={contentHtml}/>
  )
}

ParagraphSection.propTypes = {
  section: PropTypes.shape({
    heading: PropTypes.string,
    content: PropTypes.string,
    fields: PropTypes.shape({
      contentImg: PropTypes.string,
    })
  }),
  className: PropTypes.string
}

ParagraphSection.defaultProps = {
  section: {
    heading: '',
    content: '',
    fields: {
      contentImg: '',
    }
  },
  className: 'my-6 leading-loose'
}

export const query = graphql`
    fragment ParagraphSection on STRAPI__COMPONENT_SECTION_PARAGRAPH {
        id
        heading
        strapi_component
        content
        fields {
          contentImg
        }
    }
`

export default ParagraphSection
